// extracted by mini-css-extract-plugin
export default {"wrapper":"closeButton-module__wrapper__+QLgg"};